import { useContext } from 'react';
import { TranslationContext } from '../i18n/TranslationContext';

export const useTranslation = () => useContext(TranslationContext);
